class BackToTopButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.backToTopBtn = document.querySelector('back-to-top')
    this.hiddenClass = 'back-to-top--hide';
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.backToTopBtn.addEventListener('click', (e) => {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    });

    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    this.currentScrollTop = scrollTop;

    if (this.currentScrollTop >= 750) {
      this.classList.remove(this.hiddenClass);
    } else {
      this.classList.add(this.hiddenClass);
    }
  }
}

customElements.define('back-to-top', BackToTopButton);